export const new_apis = [
  // Assessments
  'assessments/approve',
  'assessments/complete',
  'assessments/create-link',
  'assessments/get-team-assessments',
  'assessments/invite',
  'assessments/renew',
  'assessments/send-reminder',
  'assessments/get-details',
  'assessments/start-invite-assessment',

  // Auth
  'auth/reset-password',
  'auth/login',
  'auth/logout',
  'auth/management-groups',
  'auth/set-access-token',

  // Admin
  'admin/auth/me',
  'admin/stats/dashboard',
  'admin/orgs',
  'admin/orgs/types',
  'admin/orgs/options',
  'admin/orgs/detail',
  'admin/orgs/deactivation',
  'admin/orgs/reactivation',
  'admin/orgs/people',

  // Chat
  'chat/get-answer',
  'chat/send-question',
  'chat/start-new-chat',
  'chat/get-ollie-help',

  // Orgs
  'orgs/inventory',

  // Payments
  'payments/checkout',
  'payments/create-user-and-checkout',
  'payments/get-payment-details',
  'payments/success',
  'payments/bill-me-later',

  // Persons
  'persons/search',
  'persons/update',
  'persons/search-for-invite',
  'persons/validate-invite-email',
  'persons/get-basic',
  'persons/update-basic',
  'persons/export',
  'persons/delete',

  // Preferences
  'preferences/get-user-preferences',
  'preferences/save-user-preferences',

  // Products
  'products/special-product',
  'products/standard-products',

  // Management
  'select-management-group',
];
